module.exports = __webpack_public_path__ + "assets/b6051b1d0358d7cbcd9fdb3d91448d27.png";